module.exports = __webpack_public_path__ + "static/media/ShopifyLogo.0f1dba5f.png";